import React from 'react';
import { MenuItem, TextField } from '@material-ui/core';
import clsx from 'clsx';
import useStyles from 'app/cluster-styles/useStyles';
import SectionCard from './SectionCard';

function getVolumeError(value, volSizeLimits) {
    if (!value && value !== 0) return '';
    if (value === '') return '';
    if (/[a-zA-Z!@#$%^&*()_+\-=[\]{};':"\\|/,.|~<>?\s]/.test(value)) return 'Must be a valid number.';
    const num = parseInt(value, 10);
    if (isNaN(num)) return 'Must be a valid number.';
    if (num < volSizeLimits.min || num > volSizeLimits.max) {
        return `Must be a number between ${volSizeLimits.min} and ${volSizeLimits.max}`;
    }
    return '';
}

export default function StorageSettingsSection({ form, setField, provider, volSizeLimits, shareOptions }) {
    const classes = useStyles();

    const serverVolumeSize = form.serverVolumeSize || '';
    const nodeVolumeSize = form.nodeVolumeSize || '';
    const share = form.share || 'nfs';
    const idlePurgeS = form.idlePurgeS ?? '';

    const serverVolumeError = getVolumeError(serverVolumeSize, volSizeLimits);
    const nodeVolumeError = getVolumeError(nodeVolumeSize, volSizeLimits);

    return (
        <SectionCard icon="storage" title="Storage Settings">
            <div style={{ display: 'flex', gap: '16px', marginBottom: '16px', alignItems: 'flex-start' }}>
                <TextField
                    className={clsx(classes.input)}
                    style={{ flex: 1 }}
                    id={`${provider}_server-volume_size`}
                    name="volume_size"
                    label="Server Volume (GB)"
                    type="text"
                    variant="outlined"
                    value={serverVolumeSize}
                    onChange={(e) => setField('serverVolumeSize', e.target.value)}
                    placeholder={`Disk size of the Cluster Head Node (Min: ${volSizeLimits.min}, Max: ${volSizeLimits.max})`}
                    error={Boolean(serverVolumeError)}
                    helperText={serverVolumeError}
                />
                <TextField
                    className={clsx(classes.input)}
                    style={{ flex: 1 }}
                    id={`${provider}_node-volume_size`}
                    name="node_volume_size"
                    label="Node Volume (GB)"
                    type="text"
                    variant="outlined"
                    value={nodeVolumeSize}
                    onChange={(e) => setField('nodeVolumeSize', e.target.value)}
                    placeholder={`Disk size of the Cluster Nodes (Min: ${volSizeLimits.min}, Max: ${volSizeLimits.max})`}
                    error={Boolean(nodeVolumeError)}
                    helperText={nodeVolumeError}
                />
                {shareOptions && (
                    <TextField
                        select
                        className={clsx(classes.input)}
                        style={{ flex: 1 }}
                        id={`${provider}_share`}
                        name="share"
                        label="Shared File System"
                        variant="outlined"
                        value={share}
                        onChange={(e) => setField('share', e.target.value)}
                        SelectProps={{
                            MenuProps: { PaperProps: { style: { maxHeight: 300 } } },
                        }}
                    >
                        {shareOptions.map((opt) => (
                            <MenuItem key={opt.value} id={`${provider}_${opt.value}`} value={opt.value}>
                                {opt.label}
                            </MenuItem>
                        ))}
                    </TextField>
                )}
            </div>
            <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                <TextField
                    className={clsx(classes.input)}
                    style={{ flex: 1 }}
                    id={`${provider}_idle_purge_s`}
                    name="idle_purge_s"
                    label="Idle Purge Time (S)"
                    type="number"
                    variant="outlined"
                    value={idlePurgeS}
                    onChange={(e) => setField('idlePurgeS', e.target.value)}
                    inputProps={{ min: 0 }}
                />
            </div>
        </SectionCard>
    );
}
